import { FormBuilder } from '../features/form-builder';

export function FormBuilderPage() {
  return (
    <div className="h-[calc(100vh-4rem)]">
      <FormBuilder />
    </div>
  );
}
